module.exports = __webpack_public_path__ + "static/media/home8.ff3b8eeb.jpg";